import { useState, useCallback, useEffect } from "react";
import { ButtonGroup } from "react-bootstrap";

// Hook
import useStickyHeader from "hooks/useStickyHeader";
import useTable from "hooks/useTable";

// Component
import Button from "components/Button";
import InlineTitle from "components/InlineTitle";
import TrustedIdentityProviderTable from "./TrustedIdentityProviderTable";
import AddOrEditTrustedIdentityProviderModal from "../modals/AddOrEditTrustedIdentityProviderModal";
import DeleteModal from "../modals/DeleteModal";

// Controller
import controller from "../controller";

// Const
import { tableColumn } from "../const";

const defaultModalStatus = {
  addAndEdit: {
    status: false,
    disabled: false,
  },
  delete: {
    status: false,
    disabled: true,
  }
};

const TrustedIdentityProvider = (props) => {
  const {
    selectedOrg,
    originMetaDataSetList,
    successCallback
  } = props;

  const {
    tableRef,
    stickyStyle
  } = useStickyHeader();

  // State
  const [modalStatus, setModalStatus] = useState({ ...defaultModalStatus });
  const [currentMetadataSetList, setCurrentMetadataSetList] = useState(originMetaDataSetList);
  const [selectedMetadataSet, setSelectedMetadataSet] = useState(null);
  const [deletedMetadataSetId, setDeletedMetadataSetId] = useState(null);

  // Hook
  const { tableData, getTableHeader, getCurrentPageData } = useTable(originMetaDataSetList, tableColumn.metadataSet);

  const changeModalStatus = useCallback((type, value) => {
    setModalStatus({ ...modalStatus, [type]: { status: value } });
  }, [modalStatus]);

  // Side effect
  useEffect(() => {
    setCurrentMetadataSetList(getCurrentPageData(false));
  }, [originMetaDataSetList, tableData]);

  return (
    <div className="mb-5">
      <InlineTitle label="TRUSTED IDENTITY PROVIDER ( IDP )" isNonUnderline />
      <div className="d-flex justify-content-between mt-3 mb-2">
        <ButtonGroup>
          <Button
            label="ec211f7c20"
            className="btn-grey"
            onClick={() => {
              setSelectedMetadataSet(null);
              changeModalStatus('addAndEdit', true);
            }}
          />
          <Button
            label="f2a6c498fb"
            className="btn-grey"
            disabled={!controller.getDeleteButtonState(currentMetadataSetList)}
            onClick={() => {
              setDeletedMetadataSetId(null);
              changeModalStatus('delete', true)
            }}
          />
        </ButtonGroup>
      </div>

      <TrustedIdentityProviderTable
        tableRef={tableRef}
        stickyStyle={stickyStyle}
        tableHeader={getTableHeader}
        currentMetaDataSetList={currentMetadataSetList}
        changeModalStatus={changeModalStatus}
        checkedAllState={() => controller.getCheckAllState(currentMetadataSetList)}
        toggleCheckedAll={() => setCurrentMetadataSetList(controller.toggleCheckedAll(currentMetadataSetList))}
        toggleChecked={index => setCurrentMetadataSetList(controller.toggleChecked(currentMetadataSetList, index))}
        selectMetadataSetCallback={metadataSet => setSelectedMetadataSet(metadataSet)}
        handleDelete={id => setDeletedMetadataSetId(id)}
      />

      {/* Add and edit modal */}
      <AddOrEditTrustedIdentityProviderModal
        selectedOrg={selectedOrg}
        modalStatus={modalStatus}
        changeModalStatus={changeModalStatus}
        selectedMetadataSet={selectedMetadataSet}
        successCallback={successCallback}
      />

      {/* Delete modal */}
      <DeleteModal
        modalStatus={modalStatus}
        selectedOrg={selectedOrg}
        sourceList={currentMetadataSetList}
        selectedId={deletedMetadataSetId}
        title="c4bd569bd6"
        description="0af46c7f98"
        changeModalStatus={() => changeModalStatus('delete', false)}
        execute={(orgId, idList) => controller.deleteMetadataSet(orgId, idList)}
        successCallback={successCallback}
      />
    </div>
  );
};

export default TrustedIdentityProvider;
